import { render, staticRenderFns } from "./news-notice-page-detail.vue?vue&type=template&id=890ea3a8&scoped=true&"
import script from "./news-notice-page-detail.vue?vue&type=script&lang=js&"
export * from "./news-notice-page-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890ea3a8",
  null
  
)

export default component.exports